/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Analytics Reports API
 * API для генерации PDF/XLSX отчетов по аналитике медицинских клиник.

Все отчеты генерируются асинхронно в фоновом режиме. 
После создания задачи вы получаете `jobId` (UUID), по которому можно отслеживать статус и скачать готовый файл.

**Типы отчетов:**
- Общие показатели
- KPI по записям
- Подтверждение записи
- Отмена записи
- Статистика по виджету
- Статистика по отзывам
- Статистика по источникам записей

 * OpenAPI spec version: 1.0.0
 */

import type { RequestHandlerOptions } from "msw"
import { delay, HttpResponse, http } from "msw"

export const getAuthenticateUserMockHandler = (
	overrideResponse?:
		| void
		| ((
				info: Parameters<Parameters<typeof http.get>[1]>[0],
		  ) => Promise<void> | void),
	options?: RequestHandlerOptions,
) => {
	return http.get(
		"*/auth",
		async (info: Parameters<Parameters<typeof http.get>[1]>[0]) => {
			await delay(300)
			if (typeof overrideResponse === "function") {
				await overrideResponse(info)
			}

			return new HttpResponse(null, { status: 200 })
		},
		options,
	)
}
export const getAuthMock = () => [getAuthenticateUserMockHandler()]
